<script lang="ts">
    import { onMount } from "svelte"
    import CookieSet from "./cookieSet.svelte"
    $: iframeTitle = "testrest"

    let setHeight = (element) => {
        element.style.height = (element.offsetWidth / 16) * 9 + "px"
    }
</script>

<CookieSet cookieName="{'googleMaps'}" textPosition="{'unten'}" background="{'rgba(44, 44, 44, 0.4)'}">
    <iframe
        use:setHeight
        id="iframe"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2510.8843160281504!2d11.046507612986247!3d50.99980984753832!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a46d575a841fe1%3A0xd6703e9ebe1ca279!2sErfurt%20Wasserski-%20und%20Wakeboardanlage!5e0!3m2!1sde!2sde!4v1682691189533!5m2!1sde!2sde"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>
</CookieSet>

<style>
    iframe {
        width: 100%;
        max-width: 100%;
        border: 0;
    }
</style>
